module.exports = __webpack_public_path__ + "static/aws-partner-network-logo-e394d88baf33b97cf3ca8fb03bd6c216.png";